import { clientApi } from 'api';
import { SearchQuery } from 'dashboard/_redux/actions/users';
import { ITour, ITourFormValues, ITourStep } from 'client/models/ITour';

const baseUrl = '/dashboard/tours';

export const getAllTours = (isServer = false) => async (
  searchQuery: SearchQuery<ITour>,
) => {
  const response = await clientApi.get(`${baseUrl}`, { params: searchQuery });

  // Transformer la réponse au format PaginatedResponse attendu par le DataTable
  const { tours = [], total = 0 } = response.data;
  
  return {
    items: tours,
    totalItems: total,
    currentPage: searchQuery.page || 1,
    totalPages: Math.ceil(total / (searchQuery.limit || 10)),
  };
};

export const getTourById = (isServer = false) => async (id: string) => {
  const { data } = await clientApi.get<{ tour: ITour }>(
    `${baseUrl}/${id}`,
  );

  return data.tour;
};

export const updateTour = () => async (
  tourData: Partial<ITourFormValues>,
  tourId?: string,
) => {
  const response = await clientApi.put(
    `${baseUrl}/${tourId}`,
    tourData,
  );

  return response.data.tour;
};

export const deleteTourById = () => async (tourId: string) => {
  await clientApi.delete(`${baseUrl}/${tourId}`);
};

export const createTour = () => async (
  tourData: ITourFormValues,
) => {
  const response = await clientApi.post(`${baseUrl}`, tourData);

  return response.data.tour;
};

// Gestion des étapes
export const addStepToTour = () => async (
  tourId: string,
  stepData: Omit<ITourStep, 'order'>,
) => {
  const response = await clientApi.post(`${baseUrl}/${tourId}/steps`, stepData);

  return response.data.tour;
};

export const updateStepInTour = () => async (
  tourId: string,
  stepOrder: number,
  stepData: Partial<ITourStep>,
) => {
  const response = await clientApi.put(
    `${baseUrl}/${tourId}/steps/${stepOrder}`,
    stepData,
  );

  return response.data.tour;
};

export const deleteStepFromTour = () => async (
  tourId: string,
  stepOrder: number,
) => {
  const response = await clientApi.delete(
    `${baseUrl}/${tourId}/steps/${stepOrder}`,
  );

  return response.data.tour;
};
